import {
  IDLocal,
  ISmartFieldsFactoryConfig,
  ISmartFieldsInstance,
} from '@components/SmartField/types';
import { generateDeviceId } from '@utils/deviceId';

export interface IUseSmartFieldsData {
  fields: ISmartFieldsInstance;
  dlocal: IDLocal;
  deviceId: number;
}

const defaultConfig = { locale: 'es', country: 'MX' };

const useSmartFields = ({
  config = defaultConfig,
  apiKey,
}: {
  config?: ISmartFieldsFactoryConfig;
  apiKey: string;
}): IUseSmartFieldsData => {
  const dlocal = window.dlocal(apiKey);
  const fields = dlocal.fields(config);
  const deviceId = generateDeviceId();
  return { fields, dlocal, deviceId };
};

export default useSmartFields;
